export const BrandId = {
    Nav: 'nav',
    AltaSp: 'altasp',
    AltaRj: 'altarj',
    Alvaro: 'alvaro',
    Atalaia: 'atalaia',
    Bronstein: 'bronstein',
    CedicCedilab: 'cedilab',
    Cerpe: 'cerpe',
    Cytolab: 'cytolab',
    Delboni: 'delboni',
    Deliberato: 'deliberato',
    Exame: 'exame',
    FrischmannAisengart: 'frischmann',
    GilsonCidrim: 'gilsoncidrim',
    ImageMemorial: 'imagememorial',
    Itulab: 'itulab',
    Lamina: 'lamina',
    LaminaDiagnosticos: 'laminasc',
    Lavoisier: 'lavoisier',
    Leme: 'leme',
    OswaldoCruz: 'oswaldocruz',
    Previlab: 'previlab',
    SalomaoZoppi: 'salomaoezoppi',
    SergioFranco: 'sergiofranco',
    ValeClin: 'valeclin',
    SaoCamilo: 'saocamilordi',
    MultiImagemRJ: 'multiimagemrio',
    MultiImagemPetropolis: 'multiimagempetropolis',
    CDPIRIO: 'cdpirio',
    CDPI: 'cdpi',
    CerpeBoris: 'cerpeboris',
    ImageLeme: 'imageleme',
    SergioFrancoCDPI: 'sergiofrancocdpi',
} as const

export type BrandIdType = (typeof BrandId)[keyof typeof BrandId]

export type BrandType = {
    id: number
    mappingId: BrandIdType
    name: string
    params: string[]
    cities: string[]
}

export const Brand: { [key in BrandIdType]: BrandType } = {
    [BrandId.Nav]: {
        id: 0,
        mappingId: BrandId.Nav,
        name: 'Nav Dasa',
        params: ['nav'],
        cities: [''],
    },
    [BrandId.AltaSp]: {
        id: 19,
        mappingId: BrandId.AltaSp,
        name: 'Alta',
        params: ['altadiagnosticos'],
        cities: ['Barueri', 'São Paulo'],
    },
    [BrandId.AltaRj]: {
        id: 19,
        mappingId: BrandId.AltaRj,
        name: 'Alta',
        params: ['altadiagnosticosrj'],
        cities: ['Rio de Janeiro'],
    },
    [BrandId.Alvaro]: {
        id: 10,
        mappingId: BrandId.Alvaro,
        name: 'Alvaro',
        params: ['alvaro'],
        cities: ['Cascavel', 'Foz do Iguaçu'],
    },
    [BrandId.Atalaia]: {
        id: 14,
        mappingId: BrandId.Atalaia,
        name: 'Atalaia',
        params: ['atalaia'],
        cities: ['Aparecida De Goiânia', 'Bela Vista', 'Goiânia', 'Trindade', 'Vila Brasilia'],
    },
    [BrandId.Bronstein]: {
        id: 3,
        mappingId: BrandId.Bronstein,
        name: 'Bronstein',
        params: ['bronstein'],
        cities: ['Duque de Caxias', 'Itaguaí', 'Macaé', 'Nilópolis', 'Niterói', 'Nova Iguaçu', 'Rio de Janeiro', 'Teresópolis'],
    },
    [BrandId.CedicCedilab]: {
        id: 101,
        mappingId: BrandId.CedicCedilab,
        name: 'Cedic Cedilab',
        params: ['cediccedilab'],
        cities: ['Cuiabá', 'Várzea Grande'],
    },
    [BrandId.Cerpe]: {
        id: 34,
        mappingId: BrandId.Cerpe,
        name: 'Cerpe',
        params: ['cerpe'],
        cities: [
            'Abreu e Lima',
            'Bezerros',
            'Cabo De Santo Agostinho',
            'Camaragibe',
            'Caruaru',
            'Goiana',
            'Gravatá',
            'Igarassu',
            'Jaboatão dos Guararapes',
            'Limoeiro',
            'Olinda',
            'Paulista',
            'Recife',
            'São José',
            'São Lourenço',
            'Timbauba',
            'Vitória de Santo Antão',
        ],
    },
    [BrandId.Cytolab]: {
        id: 27,
        mappingId: BrandId.Cytolab,
        name: 'Cytolab',
        params: ['cytolab'],
        cities: ['Arujá', 'FERRAZ DE VASCONCELOS', 'GUARAREMA', 'ITAQUAQUECETUBA', 'MOGI DAS CRUZES', 'POÁ', 'SUZANO'],
    },
    [BrandId.Delboni]: {
        id: 1,
        mappingId: BrandId.Delboni,
        name: 'Delboni',
        params: ['delboni'],
        cities: ['BARUERI', 'COTIA', 'GUARULHOS', 'OSASCO', 'SANTO ANDRÉ', 'SANTOS', 'SÃO BERNARDO DO CAMPO', 'SÃO PAULO'],
    },
    [BrandId.Deliberato]: {
        id: 102,
        mappingId: BrandId.Deliberato,
        name: 'Deliberato',
        params: ['deliberato'],
        cities: ['ARUJÁ', 'GUARULHOS', 'ITAQUAQUECETUBA', 'MOGI DAS CRUZES', 'POÁ', 'Santa Isabel', 'SUZANO'],
    },
    [BrandId.Exame]: {
        id: 15,
        mappingId: BrandId.Exame,
        name: 'Exame',
        params: ['exame'],
        cities: ['BRASÍLIA', 'PLANO PILOTO', 'VALPARAÍSO DE GOIÁS', 'ÁGUAS LINDAS DE GOIÁS', 'FORMOSA', 'LUZIÂNIA'],
    },
    [BrandId.FrischmannAisengart]: {
        id: 8,
        mappingId: BrandId.FrischmannAisengart,
        name: 'Frischmann Aisengart',
        params: ['frischmann', 'frischmannaisengart'],
        cities: [
            'Araucária',
            'Campina Grande do Sul',
            'Campo Largo',
            'COLOMBO',
            'Curitiba',
            'Fazenda Rio Grande',
            'Guaratuba',
            'Matinhos',
            'Paranaguá',
            'Pinhais',
            'SÃO JOSÉ DOS PINHAIS',
            'São Mateus do sul',
        ],
    },
    [BrandId.GilsonCidrim]: {
        id: 37,
        mappingId: BrandId.GilsonCidrim,
        name: 'Gilson Cidrim',
        params: ['gilsoncidrim'],
        cities: [
            'CABO DE SANTO AGOSTINHO',
            'CAMARAGIBE',
            'CARUARU',
            'Gravata',
            'Ipojuca',
            'Jaboatao Dos Guararapes',
            'LIMOEIRO',
            'OLINDA',
            'Palmares',
            'PAULISTA',
            'RECIFE',
            'Ribeirao',
            'Santa Cruz Do Capibaribe',
            'Surubim',
            'Vitoria De Santo Antao',
        ],
    },
    [BrandId.ImageMemorial]: {
        id: 12,
        mappingId: BrandId.ImageMemorial,
        name: 'Image Memorial',
        params: ['image', 'imagememorial'],
        cities: ['LAURO DE FREITAS', 'SALVADOR'],
    },
    [BrandId.Itulab]: {
        id: 105,
        mappingId: BrandId.Itulab,
        name: 'Itulab',
        params: ['itulab'],
        cities: ['Itu', 'Porto Feliz', 'Salto'],
    },
    [BrandId.Lamina]: {
        id: 4,
        mappingId: BrandId.Lamina,
        name: 'Lâmina',
        params: ['lamina', 'laminarj'],
        cities: ['Duque de Caxias', 'Niterói ', 'Rio de Janeiro'],
    },
    [BrandId.LaminaDiagnosticos]: {
        id: 13,
        mappingId: BrandId.LaminaDiagnosticos,
        name: 'Lâmina Diagnósticos',
        params: ['laminadiagnosticos', 'laminasc'],
        cities: ['FLORIANÓPOLIS', 'SÃO JOSÉ'],
    },
    [BrandId.Lavoisier]: {
        id: 2,
        mappingId: BrandId.Lavoisier,
        name: 'Lavoisier',
        params: ['lavoisier'],
        cities: [
            'BARUERI',
            'CAIEIRAS',
            'Campinas',
            'CARAPICUÍBA',
            'COTIA',
            'DIADEMA',
            'GUARULHOS',
            'ITAPEVI',
            'MAUÁ',
            'OSASCO',
            'Praia Grande ',
            'SANTO ANDRÉ',
            'SÃO BERNARDO DO CAMPO',
            'SÃO CAETANO DO SUL',
            'São José dos Campos',
            'SÃO PAULO',
            'São Vicente',
            'TABOÃO DA SERRA',
        ],
    },
    [BrandId.Leme]: {
        id: 40,
        mappingId: BrandId.Leme,
        name: 'Leme',
        params: ['leme'],
        cities: ['LAURO DE FREITAS', 'SALVADOR'],
    },
    [BrandId.OswaldoCruz]: {
        id: 39,
        mappingId: BrandId.OswaldoCruz,
        name: 'Oswaldo Cruz',
        params: ['oswaldocruz', 'laboratoriooswaldocruz'],
        cities: ['São Jose dos Campos'],
    },
    [BrandId.Previlab]: {
        id: 32,
        mappingId: BrandId.Previlab,
        name: 'Previlab',
        params: ['previlab'],
        cities: [
            'AMERICANA',
            'CAPIVARI',
            'CERQUILHO',
            'IRACEMÁPOLIS',
            'LARANJAL PAULISTA',
            'LIMEIRA',
            'PIRACICABA',
            'RIO DAS PEDRAS',
            'SÃO PEDRO',
            'TIETÊ',
        ],
    },
    [BrandId.SalomaoZoppi]: {
        id: 42,
        mappingId: BrandId.SalomaoZoppi,
        name: 'Salomão Zoppi',
        params: ['salomaozoppi'],
        cities: ['OSASCO', 'SÃO PAULO'],
    },
    [BrandId.SergioFranco]: {
        id: 24,
        mappingId: BrandId.SergioFranco,
        name: 'Sérgio Franco',
        params: ['sergiofranco'],
        cities: [
            'Duque de Caxias',
            'Itaboraí',
            'Itaguaí',
            'Maricá',
            'Niterói',
            'Nova Iguaçu',
            'Petrópolis',
            'Rio de Janeiro',
            'São Gonçalo',
            'São João de Meriti',
        ],
    },
    [BrandId.ValeClin]: {
        id: 59,
        mappingId: BrandId.ValeClin,
        name: 'ValeClin',
        params: ['valeclin'],
        cities: ['Caraguatatuba', 'JACAREI', 'São José dos Campos'],
    },
    [BrandId.SaoCamilo]: {
        id: 127,
        mappingId: BrandId.SaoCamilo,
        name: 'São Camilo',
        params: ['saocamilo'],
        cities: [''],
    },
    [BrandId.MultiImagemRJ]: {
        id: 29,
        mappingId: BrandId.MultiImagemRJ,
        name: 'Multi-Imagem RJ',
        params: ['multiimagemrj'],
        cities: [''],
    },
    [BrandId.MultiImagemPetropolis]: {
        id: 28,
        mappingId: BrandId.MultiImagemPetropolis,
        name: 'Multi-Imagem Petrópolis',
        params: ['multiimagempetropolis'],
        cities: [''],
    },
    [BrandId.CDPIRIO]: {
        id: 25,
        mappingId: BrandId.CDPIRIO,
        name: 'CDPI RJ',
        params: ['cdpirj'],
        cities: [''],
    },
    [BrandId.CDPI]: {
        id: 17,
        mappingId: BrandId.CDPI,
        name: 'CDPI Niterói',
        params: ['cdpiniteroi'],
        cities: [''],
    },
    [BrandId.CerpeBoris]: {
        id: 342016,
        mappingId: BrandId.CerpeBoris,
        name: 'Cerpe Boris',
        params: ['cerpeboris'],
        cities: [''],
    },
    [BrandId.ImageLeme]: {
        id: 4012,
        mappingId: BrandId.ImageLeme,
        name: 'Image Leme',
        params: ['imageleme'],
        cities: [''],
    },
    [BrandId.SergioFrancoCDPI]: {
        id: 242517,
        mappingId: BrandId.SergioFrancoCDPI,
        name: 'Sergio Fraco CDPI',
        params: ['sergiofrancocdpi'],
        cities: [''],
    },
}
